module.exports = __webpack_public_path__ + "static/media/renewals.2be297ce.svg";